import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from "@material-ui/core/DialogContentText";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
    black: {
        color: 'black',
    },
}));

const DownloadExtensionDialog = props => {
    const classes = useStyles();

    return (
        <div>
            <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Download Chrome Extension</DialogTitle>
                <DialogContent>
                    <DialogContentText variant={"body1"} className={classes.black}>
                        <p>You are about to download our Google Chrome Extension. This extension will add functionality
                            to your chrome browser that will significantly enhance your experience with
                            JunctionBox.io.</p>
                        <p>While we are in development mode, you need to jump through a few hoops to get it
                            installed.</p>
                        <p>After you click the <strong>Download</strong> button below and the extension file downloads
                            to your computer, follow these steps to install it:</p>
                        <ol>
                            <li>Unzip the downloaded zip file using any of several tools. On Windows, WinZip and 7-Zip
                                are very popular.
                            </li>
                            <li>Open your Google Chrome web browser.</li>
                            <li>Go to chrome://extensions/. You may have to type this URL into your address bar.</li>
                            <li>Check the box for Developer mode in the top right. Flick it on.</li>
                            <li>Click on the "Load unpacked" button and find the unzipped folder for the zip file you
                                downloaded. <strong>Choose the unzipped FOLDER</strong> (not the zip file). Click on the
                                OK button to install that Chrome extension.
                            </li>
                            <li>You should see a little tree icon in the upper right corner of your Chrome, where your
                                other extensions are listed.
                            </li>
                            <li>Finally, change your security preferences. Pull down the upper right menu in Chrome ().
                                Under Settings -> Privacy and Security -> Site Settings -> Cookies and site data, make
                                sure "Block third-party cookies" is unchecked.
                            </li>
                            <li>Navigate to a friend's profile page. You may have to refresh after navigating.</li>
                        </ol>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        id={"download-extension-cancel"}
                        onClick={props.handleClose}
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        id={"download-extension-proceed"}
                        onClick={() => {
                            let a = document.createElement('a');
                            a.setAttribute('type', 'application/zip');
                            a.setAttribute('download', 'junctionbox-ext.zip');
                            a.href = '/junctionbox-ext.zip';
                            a.click();
                            props.handleClose();
                        }}
                        color="primary"
                    >
                        Download Chrome Extension
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DownloadExtensionDialog
